import AnchorsGroupPic from '../../assets/GuestHome/about-anchors.jpg';
import BikiniReportPic from '../../assets/GuestHome/bikini-report.jpg';
import FanzonePic from '../../assets/GuestHome/NNL-Fanzone.jpg';
import NNL_LOGO from '../../assets/NakedNewsLive/NNL_283x140.png';


export const CAROUSEL_CONTENT = {
  'MEET_OUR_ANCHORS': {
    'heading1': 'Introducing our',
    'heading2': 'talented Hosts!',
    'content': 'The Naked News cast is made up of a diverse group of gorgeous women!  They\'re all confident and secure and love showing off their personalities and their bodies.  From reporting the news to inviting you into their personal lives, once you\'ve experienced all they have to offer, you\'ll be hooked!',
    'image': AnchorsGroupPic,
    'target': '_self',
    'url': '/account/purchase',
  },
  'FANZONE': {
    'heading1': null,
    'heading2': null,
    'content': 'Discover the intimate side of the worlds most daring Stars! Come and introduce yourself, and chat live with these provocative personalities who will perform multiple nude shows every week! Access all past shows now while you wait for the next one!',
    'image': FanzonePic,
    'url': '/account/purchase?_anchor=241&_shortUrl=live',
    'target': '_self',
    'logo': NNL_LOGO,
  },
  'BIKINI_REPORT': {
    'heading1': 'The Bikini Report:',
    'heading2': 'Totally free!',
    'content': 'Follow us on TikTok! @thebikinireport is where our stunning cast of anchors and guests present current events! Dressed in barely there outfits, you\'ll be hard pressed to absorb what they\'re saying the 1st time you watch. It\'ll quickly become you #1 source for news on the go! ',
    'image': BikiniReportPic,
    'target': '_blank',
    'url': 'https://www.tiktok.com/@thebikinireport',
  },
};
